// extracted by mini-css-extract-plugin
export default {"assistantMessage":"BBwSoWtN5wFGETzW6y5x","assistantText":"Kd4QgOJo5UmwOnCI024a","table":"JCjhlgs1roWR035ILnvS","thinkingText":"MI1Bc34fmKSwOivJJzUW","shimmer":"p8RPqpIs7Eaua2bhmbTH"};